import React from 'react';

type ThumbsUpIconProps = { width?: string; height?: string; color?: string };

function ThumbsUpIcon({
  width = '23',
  height = '22',
  color = 'black',
}: ThumbsUpIconProps) {
  return (
    <svg
      xmlns='http://www.w3.org/2000/svg'
      width={width}
      height={height}
      viewBox='0 0 23 22'
      fill='none'
    >
      <path
        d='M6.68359 21.0039V10.0039M1.68359 12.0039V19.0039C1.68359 20.1085 2.57902 21.0039 3.68359 21.0039H17.1098C18.5905 21.0039 19.8498 19.9236 20.075 18.4601L21.1519 11.4601C21.4315 9.6428 20.0254 8.00391 18.1868 8.00391H14.6836C14.1313 8.00391 13.6836 7.55619 13.6836 7.00391V3.46975C13.6836 2.1079 12.5796 1.00391 11.2178 1.00391C10.8929 1.00391 10.5986 1.1952 10.4667 1.49203L6.94753 9.41004C6.78703 9.77117 6.42891 10.0039 6.03372 10.0039H3.68359C2.57902 10.0039 1.68359 10.8993 1.68359 12.0039Z'
        stroke={color}
        stroke-width='2'
        stroke-linecap='round'
        stroke-linejoin='round'
      />
    </svg>
  );
}
export default ThumbsUpIcon;
